import { Position, Toaster, ToastProps } from '@blueprintjs/core';

const ToasterInstance = Toaster.create(
  {
    className: 'fixed-important',
    position: Position.TOP
  },
  document.body
);

export default function Toast(props: ToastProps): string {
  return ToasterInstance.show(props);
}
